export const PENDING = 'PENDING';
export const COMPLETED = 'COMPLETED';
export const ONHOLD = 'ONHOLD';
export const WITHDRAWN = 'WITHDRAWN';
export const REOPENED = 'REOPENED';
export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_PARAMETERS = ['Name', 'GST', 'PAN', 'CIN'];
export const ENTER = 'Enter';
export const DATE_TEXT = 'date';